<template>
  <section>
    <p class="question">{{ model.question.promptHtml }}</p>
    <div v-if="respondable">
      <textarea-autogrow placeholder="Begin typing..." v-model="innerValue" @input="updateValue" :max="maxchars" />
      <div class="chars">Characters Left: {{ charsLeft }}</div>
    </div>
    <div class="response" v-else>
      <p v-html="model.response"></p>
    </div>
  </section>
</template>

<script>

  export default {
    name: 'BlastResponse',
    props: {
      model: {
        type: Object,
        required: true
      },
      maxchars: {
        type: Number,
        default: 140
      },
      respondable: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        innerValue: this.model.response || ""
      }
    },
    computed: {
      charsLeft () {
        return this.maxchars - this.innerValue.length
      }
    },
    methods: {
      save: _.debounce((model) => {
        model.DSSave()
      }, 500),
      updateValue () {
        let value = (this.innerValue.length < 5) ? null : this.innerValue
        this.$emit("input", value)
        if(value) {
          this.save(this.model)
        }
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  textarea {
    width:100%; border:1px solid #B2B2B2; resize:none; font-size:90%; padding:.5em;
  }

  .question {
    margin-bottom:2rem;
  }

  .intro {
    font-weight:300; font-size:90%;
  }

  .chars {
    text-align:right; font-size:70%;
  }

  .response {
    font-weight:300;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/blast-response.vue